module.exports = __webpack_public_path__ + "img/pic_Jurisdiction@2x.53e60e4a.png";